// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606251233/js/" + chunkId + "." + {"44":"279c0d6b","225":"b85a93c4","481":"72ac23f0","486":"f5cd59a3","770":"a1df2ecd"}[chunkId] + ".0.7358850021753587.chunk.js";
};